import {
  DEAKIN_FACULTY_FACET_ID,
  DEAKIN_TOPICS_FACET_ID,
} from '../../funnelback/deakin-config';

/** Compare Funnelback facet ids (`Name|field`) case-insensitively. */
export function facetIdsEqual(a: string, b: string): boolean {
  if (a === b) {
    return true;
  }
  const [aName, aField] = a.split('|');
  const [bName, bField] = b.split('|');
  return (
    aName?.trim().toLowerCase() === bName?.trim().toLowerCase() &&
    aField?.trim().toLowerCase() === bField?.trim().toLowerCase()
  );
}

/** Map legacy/lowercase browser URL facet keys to live Funnelback ids. */
export function canonicalizeKnownFacetId(facetId: string): string {
  const trimmed = facetId.trim();
  if (!trimmed) {
    return trimmed;
  }
  if (facetIdsEqual(trimmed, DEAKIN_TOPICS_FACET_ID)) {
    return DEAKIN_TOPICS_FACET_ID;
  }
  if (facetIdsEqual(trimmed, DEAKIN_FACULTY_FACET_ID)) {
    return DEAKIN_FACULTY_FACET_ID;
  }
  return trimmed;
}
